import { TabStyles } from '@tableau/widgets';
import { elideTextStyle } from './LayoutStyles';
import { cssClass } from './StyleFunctions';
import { PaneTitleTextStyle } from './SubplaceStyles';
import { MetadataLabelColor } from './VizPortalStyles';

const Spacing = TabStyles.Spacing;
const FontSizes = TabStyles.Typography.Sizing;
const FontColors = TabStyles.Typography.Color;

const descriptionAndTagsMaxHeight = '100px';
const descriptionAndTagsMaxWidth = 'calc(100vw - 606px)';

export const aboutHeader = cssClass('aboutHeaderClass', PaneTitleTextStyle);

export const aboutHeaderDetailsWrapper = cssClass('aboutHeaderDetailsWrapperClass', {
  paddingRight: Spacing.ExtraLargeSpace,
  paddingBottom: Spacing.ExtraLargeSpace,
  paddingLeft: Spacing.ExtraLargeSpace,
  color: FontColors.Primary,
  fontSize: FontSizes.Large
});

export const aboutHeaderDetailsTextElide = cssClass('aboutHeaderDetailsTextElideClass', elideTextStyle);

export const aboutHeaderDetailLabel = cssClass('aboutHeaderDetailLabel', MetadataLabelColor, {
  paddingBottom: Spacing.DefaultSpace
});

export const aboutHeaderDetailItem = cssClass('aboutHeaderDetailItem', {
  paddingTop: Spacing.MediumSpace,
  paddingLeft: Spacing.LargeSpace,
  paddingRight: Spacing.MediumSpace,
  flexShrink: 1,
  maxWidth: 275,
  minWidth: 0,
});

export const aboutHeaderConnectionTypeDetailItem = cssClass('aboutHeaderConnectionTypeDetailItem', {
  flexShrink: 0,
});

export const aboutHeaderConnectionTypeDetailText = cssClass('aboutHeaderConnectionTypeDetailItem', {
  flexShrink: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const aboutHeaderConnectionTypeDetailIcon = cssClass('aboutHeaderConnectionTypeDetailItem', {
  flexShrink: 0,
});

export const aboutHeaderDescriptionAndTags = cssClass('aboutHeaderDescriptionAndTags', {
  paddingTop: Spacing.MediumSpace,
  paddingLeft: Spacing.LargeSpace,
});

export const aboutHeaderDescriptionAndTagsContent = cssClass('aboutHeaderDescriptionAndTagsContent', {
  maxHeight: descriptionAndTagsMaxHeight,
  maxWidth: descriptionAndTagsMaxWidth,
  overflow: 'auto'
});

export const aboutHeaderPlaceholderText = cssClass('PlaceholderTextCell', elideTextStyle, {
  fontStyle: 'italic',
  color: FontColors.Secondary,
});

export const aboutHeaderInfoIcon = cssClass('aboutHeaderInfoIcon', {
  marginLeft: Spacing.DefaultSpace,
  verticalAlign: 'text-bottom'
});
